export const MODAL_WIDTH = "800px";
